import React, { lazy, useCallback } from 'react';
import { Suspense} from 'react';
const Bindcomponent = (props) => {
   const Comp =  useCallback(lazy(() => import(`../components/${props.component}.js`)),[])
   const obj = {...props};
    
   if(typeof props.children != undefined|| typeof props.children != 'undefined'){
       
      delete obj.children
   }

   delete obj.component
   
return (
       <Suspense>
          <Comp {...obj} >
                {props.children}
         </Comp>

             
          {/* {Object.getOwnPropertyNames(props).length > 0 ? (
            <Comp {...props} >
                {props.children}
            </Comp>
         ):(
            <Comp>
               {props.children}
            </Comp>
         )} */}
       </Suspense>
         
        
    )
}

export default  Bindcomponent 
//   export default function Bindcomponent({component, props}){
//   const Comp =  lazy(() => import(`../components/${component}.js`))
//   // alert(component)
//     return (
//        <Suspense>
//           {Object.getOwnPropertyNames(props).length > 0 ? (
            
//             <Comp {...props} />
//          ):(
//             <Comp />
//          )}
//        </Suspense>
         
        
//     )
// }

 